module.exports = __webpack_public_path__ + "img/illustration-maintenance@3x.96550b29.png";